// extracted by mini-css-extract-plugin
module.exports = {"mask":"mask-3sz7TXgt","box":"box-3fDyu6Hg","close":"close-25CVJaGk","page":"page-1WDMi7Nz"};